/* global axios */
import ApiClient from './ApiClient';

class SalesGoalsAPI extends ApiClient {
  constructor() {
    super('sales_goals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, { sales_goal: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { sales_goal: payload });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new SalesGoalsAPI();
